// ANCHOR React
import { useCallback, FormEvent } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';
import { ParagraphSmall } from 'baseui/typography';
import { Input, SIZE } from 'baseui/input';
import { FormControl } from 'baseui/form-control';

// ANCHOR Models
import { ConfirmationModalLogic } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalLogic';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Constants
import { FORM_CAPTION } from './constants';

// ANCHOR Styles
import { BLOCK, BODY_CONTENT } from './styles';

export const LyonConfirmationModalBodyInput = constant(() => {
  const [input, prompt, description] = ConfirmationModalLogic.useSelectors((state) => [
    state.handler.input,
    state.state.prompt,
    state.state.description,
  ]);

  const onChange = useCallback((event: FormEvent<HTMLInputElement>) => {
    input(event.currentTarget.value);
  }, [input]);

  return (
    <Block overrides={BLOCK}>
      {description && (
        <ParagraphSmall overrides={BODY_CONTENT}>
          {description}
        </ParagraphSmall>
      )}
      <ParagraphSmall overrides={BODY_CONTENT}>
        Please type &quot;
        <b>{`${prompt}`}</b>
        &quot; to confirm.
      </ParagraphSmall>
      <FormControl caption={FORM_CAPTION}>
        <Input
          onChange={onChange}
          placeholder={prompt}
          size={SIZE.default}
          required
        />
      </FormControl>
    </Block>
  );
});
